import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckExtraPathDetails } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';

import { IConsistencyCheckExtraPathDetails } from '@interfaces/cmModule/consistencyCheck';
import { IConsistencyCheckHistoryExtraPathMoNamesDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IPath } from '@interfaces/networkElements/networkElements';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_EXTRA_PATH_DETAILS } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckExtraPathDetailsReturned {
	extraPathDetails: IPath[];
	countOfRecords: number;
	isLoadingExtraPathDetails: boolean;
}

const useQueryConsistencyCheckExtraPathDetails = (
	params: IConsistencyCheckHistoryExtraPathMoNamesDTO,
): IUseQueryConsistencyCheckExtraPathDetailsReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<IConsistencyCheckExtraPathDetails>({
		queryKey: [CONSISTENCY_CHECK_EXTRA_PATH_DETAILS, params],
		queryFn: extractQueryParams(getConsistencyCheckExtraPathDetails),
		enabled: [
			!!params.dataModelPathId,
			!!params.dumpConsistencyId,
		],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	const extraPathData = data?.distNames.items?.map(path => ({ path })) || [];

	return {
		extraPathDetails: extraPathData,
		countOfRecords: data?.distNames?.count || 0,
		isLoadingExtraPathDetails: isInitialLoading,
	};
};

export default useQueryConsistencyCheckExtraPathDetails;
